import {Mag2LocalStorage} from "./mag2-local-storage";
import {BaseURL} from "../env/config";
import {LiveUserAuthority} from "./entity/live-user-authority";
import * as Hls from "hls.js";

export function playbackURLOf(baseURL: BaseURL, broadcastId: string) {
  return baseURL.edgeAPI + `streamers/${broadcastId}/index.m3u8`;
}

export function getFixedPlayerMode(): "NATIVE" | "HLS.JS" {
  const playerMode = Mag2LocalStorage.getPlayerMode();

  if (playerMode === "NATIVE" || (playerMode === "AUTO" && !Hls.isSupported())) {
    return "NATIVE"
  } else {
    return "HLS.JS"
  }
}

export function playbackQuery(authority: LiveUserAuthority, playerMode: "NATIVE" | "HLS.JS", time?: number) {
  const query = {
    key: Mag2LocalStorage.getClientId(),
    val: JSON.stringify({
      clientId: Mag2LocalStorage.getClientId(),
      sessionId: authority && authority.sessionId ? authority.sessionId : "",
      userId: Mag2LocalStorage.getUserId()
    }),
    player: (playerMode === "NATIVE") ? "avkit" : "hlsjs"
  };

  if (time !== undefined) {
    query['cache'] = time;
  }

  return query;
}
